<div class="content" *ngIf="shouldRenderPanel()" [class]="{
    transparent: statut == 'PENDING' || isTransporterJob(),
  }">
  <div class="header">
    <div class="title" *ngIf="
        statut != 'PENDING' &&
        statut != 'WAITING' &&
        statut != 'PRE_ASSIGN' &&
        !isTransporterJob()
      ">
      @if (hasTrajetDisplay()) {
      {{ titre }} :
      @if (distance && (distance.Km > 0 || distance.M > 0)) {
      <span>
        {{ formateDistance(distance.Km, distance.M) }}
      </span>
      }
      <span class="badge">
        {{ hours && +hours > 0 ? hours + "h" : "" }}{{ minutes }}
        {{ lable }}
      </span>
      } @else if (trajetLoadTimedOut) {
      <span class="route-unavailable">{{
        "ONROAD.ROUTE_UNAVAILABLE" | translate
        }}</span>
      } @else {
      <app-spinner color="black"></app-spinner>
      }
    </div>
    <div #bgImage class="image" *ngIf="
        statut != 'PENDING' &&
        statut != 'WAITING' &&
        statut != 'PRE_ASSIGN' &&
        !isTransporterJob()
      ">
      <img class="trajet" src="/assets/icon/trajet.svg" />

      <img [class]="{ coming: role == 'client' }" class="car" #animatedImage [src]="
          role == 'client'
            ? '/assets/icon/single-voiture-right.svg'
            : '/assets/icon/single-voiture.svg'
        " />
    </div>

    <div class="progress-text" *ngIf="statut == 'WAITING' || statut == 'PRE_ASSIGN'">
      <div *ngIf="proposed_provider">
        <p class="progress-title">
          {{ "ONROAD.PROVIDER_FOUND_TITLE" | translate }}
        </p>
        <p class="progress-subtitle">
          {{ "ONROAD.PROVIDER_FOUND_SUBTITLE" | translate }}
        </p>
        <p>
          <ion-progress-bar type="indeterminate"></ion-progress-bar>
        </p>
      </div>
      <div *ngIf="!proposed_provider">
        <p class="progress-title">
          {{ "ONROAD.SEARCHING_PROVIDER_TITLE" | translate }}
        </p>
        <p class="progress-subtitle">
          {{ "ONROAD.SEARCHING_PROVIDER_SUBTITLE" | translate }}
        </p>
        <p>
          <ion-progress-bar type="indeterminate"></ion-progress-bar>
        </p>
      </div>
    </div>
    <div class="buttons-images" *ngIf="statut == 'WAITING' || statut == 'PRE_ASSIGN'">
      <div *ngIf="proposed_provider" class="rounded-img">
        <img src="/assets/img/avatar_provider.png" alt="" />
        <p>
          {{ proposed_provider.first_name }} {{ proposed_provider.last_name }}
        </p>
      </div>
      <div class="rounded-img" *ngIf="proposed_provider">
        <ion-button (click)="click()" id="showConfirmModal">
          <ion-icon name="ban-outline"></ion-icon>
        </ion-button>
        <p>{{ buttonText }}</p>
      </div>
      <app-button [styles]="{ backgroundColor: '#1d5d9b80' }" *ngIf="!proposed_provider" class="cancel-btn"
        [innerText]="'ONROAD.CANCEL2' | translate" (onClick)="click()">
      </app-button>
    </div>

    <div *ngIf="
        statut !== 'WAITING' &&
        statut !== 'PRE_ASSIGN' &&
        (!isTransporterJob() ||
          (isTransporterJob() && pointsDistance.Km <= 1))
      " class="buttons">
      <ion-button *ngIf="!confirm" [disabled]="attent == 'INPROGRESS' || attent == 'CONFIRMED'" (click)="click()">{{
        buttonText }}</ion-button>
      <ion-button *ngIf="!confirm && role === 'prestataire'&& hasValidDestinationCoords()"
        [disabled]="attent == 'INPROGRESS' || attent == 'CONFIRMED'" (click)="openGoogleMaps()" class="go-to-map">{{
        "ONROAD.OPEN_GOOGLE_MAP" | translate }}
      </ion-button>
    </div>
  </div>
</div>